<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <h4 class="modal-title mb-0">{{ 'column-configuration.title' | translate }}</h4>
    <span *ngIf="currentSource === 'USER'" class="badge bg-primary">
      {{ 'column-configuration.source.user' | translate }}
    </span>
    <span *ngIf="currentSource === 'ORG_DEFAULT'" class="badge bg-secondary">
      {{ 'column-configuration.source.org-default' | translate }}
    </span>
  </div>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="dismiss()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <!-- Available columns -->
    <div class="col-md-6">
      <h5>{{ 'column-configuration.available-columns' | translate }}</h5>
      <div class="column-list">
        <div *ngIf="baseColumns.length > 0" class="column-group">
          <h6 class="text-muted">{{ 'column-configuration.base-columns' | translate }}</h6>
          <div
            *ngFor="let option of baseColumns"
            class="column-item"
            [class.selected]="option.selected"
            (click)="toggleColumn(option)"
          >
            <input
              type="checkbox"
              [checked]="option.selected"
              class="form-check-input me-2"
            />
            <span>{{ option.label }}</span>
          </div>
        </div>

        <div *ngIf="customFieldOptions.length > 0" class="column-group mt-3">
          <h6 class="text-muted">{{ 'column-configuration.result-fields' | translate }}</h6>
          <div
            *ngFor="let option of customFieldOptions"
            class="column-item"
            [class.selected]="option.selected"
            (click)="toggleColumn(option)"
          >
            <input
              type="checkbox"
              [checked]="option.selected"
              class="form-check-input me-2"
            />
            <span>{{ option.label }}</span>
            <span class="badge bg-secondary ms-2">result</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Selected columns (drag to reorder) -->
    <div class="col-md-6">
      <h5>{{ 'column-configuration.selected-columns' | translate }}</h5>
      <p class="text-muted small">
        {{ 'column-configuration.drag-to-reorder' | translate }}
      </p>
      <div
        cdkDropList
        class="selected-column-list"
        (cdkDropListDropped)="dropColumn($event)"
      >
        <div
          *ngFor="let option of selectedOptions"
          cdkDrag
          class="selected-column-item"
        >
          <i class="bi bi-grip-vertical me-2"></i>
          <span>{{ option.label }}</span>
          <span *ngIf="option.isCustom" class="badge bg-secondary ms-2"
            >result</span
          >
        </div>
      </div>
      <div *ngIf="selectedOptions.length === 0" class="text-muted text-center py-4">
        {{ 'column-configuration.no-columns-selected' | translate }}
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="dismiss()">
    {{ 'cancel' | translate }}
  </button>

  <!-- Reset to Default button (visible when user has override) -->
  <button
    *ngIf="currentSource === 'USER'"
    type="button"
    class="btn btn-outline-secondary"
    (click)="resetToDefault()"
    [disabled]="resetting"
  >
    <span *ngIf="resetting" class="spinner-border spinner-border-sm me-1"></span>
    {{ 'column-configuration.reset-to-default' | translate }}
  </button>

  <!-- Admin: Split button dropdown -->
  <div *ngIf="isOrgAdmin" class="btn-group">
    <button
      type="button"
      class="btn btn-primary"
      (click)="save()"
      [disabled]="saving || savingOrgDefault"
    >
      <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
      {{ 'save' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary dropdown-toggle dropdown-toggle-split"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      [disabled]="saving || savingOrgDefault || deletingOrgDefault"
    >
      <span class="visually-hidden">{{ 'column-configuration.toggle-dropdown' | translate }}</span>
    </button>
    <ul class="dropdown-menu dropdown-menu-end">
      <li>
        <a class="dropdown-item" role="button" (click)="save()">
          {{ 'column-configuration.save-for-me' | translate }}
        </a>
      </li>
      <li>
        <a class="dropdown-item" role="button" (click)="saveAsOrgDefault()">
          <span *ngIf="savingOrgDefault" class="spinner-border spinner-border-sm me-1"></span>
          {{ 'column-configuration.save-as-org-default' | translate }}
        </a>
      </li>
      <li *ngIf="hasOrgDefault"><hr class="dropdown-divider"></li>
      <li *ngIf="hasOrgDefault">
        <a class="dropdown-item text-danger" role="button" (click)="deleteOrgDefault()">
          <span *ngIf="deletingOrgDefault" class="spinner-border spinner-border-sm me-1"></span>
          {{ 'column-configuration.delete-org-default' | translate }}
        </a>
      </li>
    </ul>
  </div>

  <!-- Non-admin: Simple save button -->
  <button
    *ngIf="!isOrgAdmin"
    type="button"
    class="btn btn-primary"
    (click)="save()"
    [disabled]="saving"
  >
    <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
    {{ 'save' | translate }}
  </button>
</div>
